import { createFileRoute, redirect } from '@tanstack/react-router';

/** Bare /parent opens the shared role-aware dashboard. */
export const Route = createFileRoute('/_authed/parent/')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
